export enum AppOpenSources {
  Other = 'other',
  Deeplink = 'deeplink',
  Notification = 'notification',
}
